/**
 * @file skipLinks
 *
 * @module skipLinks
 *
 */

import $ from 'jquery';

(function($) {
  'use strict';

  var config = {
    skipWrapper  : '.fpi-skipLink',
    skipLink     : '.fpi-skipLink a',
  };

  /**
   * Extends the skipLinks module
   * @memberof module:skipLinks
   */

  function focus() {
    $(config.skipLink).focus(function() {
      $(config.skipWrapper).addClass('is-focused');
    }).blur(function () {
      $(config.skipWrapper).removeClass('is-focused');
    });
  }

  // init
  $(document).ready(function() {
    focus();
  });

})($);



// WEBPACK FOOTER //
// ./src/js/modules/skipLinks.js